import { createGetContractBasedDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { reducer, fetchData } = createGetContractBasedDataFetchSlice<any, DefaultBusinessMarketApiErrorCode>({
    dataName: 'earlySettlementDealerCallback',
    fetchCallback(endpoint: string) {
        return CpDataApi.get(endpoint).then(response => response.data);
    },
});

export default reducer;
export const fetchDealerCallback = fetchData;
